<script>
    import { navigate } from 'svelte-routing';
    
    export let casinoId;
    export let tableData;
    let players = null;

    export function updatePlayers(sfsPlayers)
    {
        players = [];
        for (let i = 0; i<sfsPlayers.size(); i++)
        {
            let sfsPlayer = sfsPlayers.getSFSObject(i);
            let player = {
                userId: sfsPlayer.getUtfString("userId"),
                userName: sfsPlayer.getUtfString("userName"),
                photo: sfsPlayer.getUtfString("photo"),
                seatNo: sfsPlayer.getInt("seatNo")
            }
            players.push(player);
        }
	}

    export function joinTable(userId, userName, photo, seatNo)
    {
        players.push({
            userId: userId,
            userName: userName,
            photo: photo,
            seatNo: seatNo
        });

        players = players;
    }

    export function leaveTable(userId)
    {
        for (let i = 0; i<players.length; i++)
            if(players[i].userId == userId)
            {
                players.splice(i, 1);
                break;
            }

        players = players;
    }

    function onTable() 
    {
        navigate("/" + casinoId + "/" + tableData.id);
    }
</script>


<div class="vbox" style="position: relative;" >
    <img class="tableImage" on:click="{onTable}" src={"/assets/" + tableData.table_type + ".png"} alt={tableData.id}}>
    <div class="hbox tablePlayers">
    {#if players}
        {#each players as player}
            <div class="vbox" style="background-color: white; margin-left: 10px;">
                <img class="userPhoto" src={player.photo} alt="User Profile">
                {player.userName}
            </div>
        {/each}
    {/if}
    </div>
    <span style="text-align: center; top: -10px; position: relative;">{tableData.name} </span>
</div>

<style>
     .tableImage {
        width: 400px;
        height: 300px;
        min-width: 400px;
        min-height: 300px;
        margin: 2em;
        cursor: pointer;
    }

    .tablePlayers {
        position: absolute;
        left: 30px;
        top: 265px;
    }

    .userPhoto {
        width: 30px;
        height: 30px;
    }
   
</style>